<div class="detail-row subtab-wrapper">
    @if (tabList && tabList.length > 0) {
      <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)" class="custom-tablist custom-subtablist" [scrollable]="true">
        @for (subtabDetails of tabList; track subtabDetails; let i = $index) {
          <p-tabPanel>
            <ng-template pTemplate="header">
              <div (click)="selectSubTab(i)" class="p-d-flex p-ai-center custom-tab-name">
                <span style="white-space: nowrap;">{{ subtabDetails?.widgetName }}</span>
              </div>
            </ng-template>
            @switch (subtabDetails?.referenceTypeName) {
              @case ('SavedSearch') {
                @if (activeSubtabIndex === i) {
                  <app-saved-search-table-view 
                    [savedSearchId]="subtabDetails.referenceId" 
                    [tabWidgetDetails]="subtabDetails" 
                    [showFlatTable]="true" 
                    [isLeftTableHide]="isLeftTableHide" 
                    [hideTableHeader]="true">
                  </app-saved-search-table-view>
                }
              }
              @case ('Workbook') {
                @if (activeSubtabIndex === i) {
                  <app-shared-workbook-listing 
                    [tabWidgetDetails]="subtabDetails" 
                    [workbookIntId]="subtabDetails.referenceId" 
                    [isLeftTableHide]="isLeftTableHide">
                  </app-shared-workbook-listing>
                }
              }
            }
          </p-tabPanel>
        }
      </p-tabView>
    } @else {
      <div class="no-data-message">
        <p>No list available</p>
      </div>
    }
  </div>